import { Component, Input, inject, ChangeDetectionStrategy } from '@angular/core';

import { NEVER, Observable } from 'rxjs';

import { MenuItem, NavigationMenuService } from '@fcom/common';
import { CmsContentType, CmsFormType, CmsTemplate, CmsViewType, PageViewType } from '@fcom/core-api';

@Component({
  selector: 'cms-child-page',
  templateUrl: './cms-child-page.component.html',
  styleUrls: ['./cms-child-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CmsChildPageComponent {
  private navigationMenuService = inject(NavigationMenuService);

  @Input()
  template$: Observable<CmsTemplate>;

  @Input()
  title$: Observable<string> = NEVER;

  activeNaviSection$: Observable<MenuItem>;

  public readonly DOCTYPE: typeof CmsContentType = CmsContentType;
  public readonly VIEWTYPE: typeof CmsViewType = CmsViewType;
  public readonly FORMTYPE: typeof CmsFormType = CmsFormType;
  public readonly PAGETYPE: typeof PageViewType = PageViewType;

  constructor() {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
  }
}
